export const FETCH_PAYMENTS = 'PAYMENTS/FETCH_REQUEST';
export const FETCH_PAYMENTS_SUCCESS = 'PAYMENTS/FETCH_SUCCESS';
export const FETCH_PAYMENTS_FAILURE = 'PAYMENTS/FETCH_FAILURE';

/** Payment dashboard filters */
export const SET_PAYMENT_DASHBOARD_FILTER = 'PAYMENTS/DASHBOARD/FILTER/SET';
export const SET_PAYMENT_DASHBOARD_FILTERS = 'PAYMENTS/DASHBOARD/FILTERS/SET';
export const CLEAR_PAYMENT_DASHBOARD_FILTER = 'PAYMENTS/DASHBOARD/FILTERS/CLEAR';
export const REMOVE_PAYMENT_DASHBOARD_FILTER = 'PAYMENTS/DASHBOARD/FILTERS/REMOVE';

export const FETCH_TOTAL_AMOUNT = 'PAYMENTS/TOTAL_AMOUNT/FETCH_REQUEST';
export const FETCH_TOTAL_AMOUNT_SUCCESS = 'PAYMENTS/TOTAL_AMOUNT/FETCH_SUCCESS';
export const FETCH_TOTAL_AMOUNT_FAILURE = 'PAYMENTS/TOTAL_AMOUNT/FETCH_FAILURE';

export const OPEN_EXPORT_PAYMENT_MODAL = 'PAYMENTS/EXPORT_MODAL/OPEN';
export const CLOSE_EXPORT_PAYMENT_MODAL = 'PAYMENTS/EXPORT_MODAL/CLOSE';
export const EXPORT_PAYMENT_REQUEST = 'PAYMENTS/EXPORT/REQUEST';
export const EXPORT_PAYMENT_SUCCESS = 'PAYMENTS/EXPORT/SUCCESS';
export const EXPORT_PAYMENT_FAILURE = 'PAYMENTS/EXPORT/FAILURE';

// Persisted filters
export const PERSISTED_ACTION_TYPES = [
  SET_PAYMENT_DASHBOARD_FILTER,
  SET_PAYMENT_DASHBOARD_FILTERS,
  CLEAR_PAYMENT_DASHBOARD_FILTER,
  REMOVE_PAYMENT_DASHBOARD_FILTER,
];
